@if (messagingData || detail) {
    <tec-collapse
        [icon]="'icon-send'"
        [title]="'OPERATIONS.DETAIL.MESSAGING.SECTION_DELIVERY' | translate"
        [expanded]="expandedCollapseSection === 'delivery'"
        (clickEvent)="toggleCollapse('delivery', $event)"
    >
        <div class="grid grid-i3">
            <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.PHONE' | translate">
                <app-phone-display [tfa]="messagingData" />
            </tec-info-group>
            <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.CHANNEL' | translate">
                <span>{{ channelLabel() }}</span>
            </tec-info-group>
            <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.DELIVERY_STATUS' | translate">
                <span>{{ deliveryStatusLabel() }}</span>
            </tec-info-group>
            <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.CODE_VALIDATED' | translate">
                <span>{{ codeValidatedLabel() }}</span>
            </tec-info-group>
            <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.ATTEMPTS' | translate">
                <tec-badge [label]="attemptsLabel()" type="square" />
            </tec-info-group>
        </div>
    </tec-collapse>

    @if (showCommunicationsSection()) {
        <tec-collapse
            [icon]="'icon-message-circle'"
            [title]="'OPERATIONS.DETAIL.MESSAGING.SECTION_COMMUNICATIONS' | translate"
            [expanded]="expandedCollapseSection === 'communications'"
            (clickEvent)="toggleCollapse('communications', $event)"
        >
            <div class="grid grid-i3">
                @for (communication of communications(); track communication.id; let first = $first) {
                    @if (!first) {
                        <tec-divider class="messaging-details__communication-divider" />
                    }
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.COMMUNICATION_CHANNEL' | translate">
                        <span>{{ communicationChannelLabel(communication) }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.COMMUNICATION_TYPE' | translate">
                        <span>{{ communicationTypeLabel(communication) }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.PHONE' | translate">
                        <app-phone-display [phone]="communication.phone" />
                    </tec-info-group>
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.DELIVERY_STATUS' | translate">
                        <span>{{ communicationStatusLabel(communication) }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.COMMUNICATION_DATE' | translate">
                        <span>{{ communication.created_at | date : 'dd/MM/yyyy - HH:mm' }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.MESSAGE_BODY' | translate">
                        <span>{{ communicationMessageLabel(communication) }}</span>
                    </tec-info-group>
                }
            </div>
        </tec-collapse>
    }

    @if (showSiblingSessionsSection()) {
        <tec-collapse
            [icon]="'icon-users'"
            [title]="'OPERATIONS.DETAIL.MESSAGING.SECTION_SIBLINGS' | translate"
            [expanded]="expandedCollapseSection === 'siblings'"
            (clickEvent)="toggleCollapse('siblings', $event)"
        >
            <div class="grid grid-i3">
                @for (session of siblingSessions(); track session.id; let first = $first) {
                    @if (!first) {
                        <tec-divider class="messaging-details__communication-divider" />
                    }
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.PHONE' | translate">
                        <app-phone-display [phone]="session.phone" />
                    </tec-info-group>
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.CHANNEL' | translate">
                        <span>{{ siblingChannelLabel(session) }}</span>
                    </tec-info-group>
                    <tec-info-group [label]="'OPERATIONS.DETAIL.MESSAGING.COMMUNICATION_DATE' | translate">
                        <span>{{ session.created_at | date : 'dd/MM/yyyy - HH:mm' }}</span>
                    </tec-info-group>
                }
            </div>
        </tec-collapse>
    }

    <tec-collapse
        [icon]="'icon-pending-check'"
        [title]="'OPERATIONS.DETAIL.TABS.DETAILS.OPERATION' | translate"
        [expanded]="expandedCollapseSection === 'operation'"
        (clickEvent)="toggleCollapse('operation', $event)"
    >
        <app-operation-detail-operation-meta
            [operationUuid]="detail?.uuid"
            [processUuid]="detail?.process_uuid"
            [startAt]="detail?.start_at"
            [endAt]="detail?.end_at"
            [totalTime]="detail?.total_time"
            triesStyle="badge"
            [triesLabel]="totalTriesLabel()"
            [typeLabel]="'OPERATIONS.MESSAGING' | translate"
        />
    </tec-collapse>
} @else {
    <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.DETAILS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
}
